import { useTranslation } from '@axo/shared/i18n';
import { Stack } from '@axo/ui-core/components/layout/item';
import { Text } from '@axo/ui-core/components/typography';
import styles from '../../../../loan.module.scss';
import { CoApplicantCitizenFormGroup } from './CoApplicantCitizenship';
import { CoApplicantDetails } from './CoApplicantDetails';
import { CoApplicantEmployment } from './CoApplicantEmployment';

export const CoAppFormGroup = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.inputGroup} data-grey={true}>
      <Stack>
        <Text size="l">
          <b>{t('AddCoApplicant.title')}</b>
        </Text>

        <Stack gap="s">
          <CoApplicantDetails />
          <CoApplicantCitizenFormGroup />
          <CoApplicantEmployment />
        </Stack>
      </Stack>
    </div>
  );
};
